/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit UploadedImagesAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function UploadedImagesAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/ImportAction/Content/UploadedImagesAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="ghost"
 size="small"
 width="100%"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../../UploadedImages/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../../UploadedImages/Content'))}
 text="Open uploaded images"
/>
{children}
</React.Fragment>)
}